import React, { useEffect } from 'react';

import Navbar from '../components/Navbar/Navbar';
import AboutBanner from '../sections/AboutBanner/AboutBanner';
import OurValues from '../sections/OurValues/OurValues';
import Team from '../sections/Team/Team';
import Footer from '../sections/Footer/Footer';

const About = () => {
    useEffect(() => {
        document.title = 'Zahnärzte Pankraz & Lichagin in Bielefeld';

        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                'content',
                'Lernen Sie die Zahnarztpraxis Pankraz & Lichagin in Bielefeld-Milse und unser Team kennen. Erfahren Sie mehr über unsere Praxis, Werte und Zahnärzte.'
            );
    }, []);

    return (
        <>
            <Navbar />
            <AboutBanner />
            <OurValues />
            <Team />
            <Footer />
        </>
    );
};

export default About;